var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eb-page',{on:{"page:afterin":_vm.onPageAfterIn}},[_c('eb-navbar',{attrs:{"large":"","largeTransparent":"","title":_vm.$text('Edit'),"eb-back-link":"Back"}}),_vm._v(" "),_c('f7-block',{staticClass:"text-align-center"},[_c('f7-preloader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }